export const previewNames: Record<
  string,
  {
    name?: string;
    heroUppercase?: boolean;
  }
> = {
  "generals-competition": { name: "generals.io" },
};
